<template>
  <transition name="modal">
    <div class="modal-mask manage-screens">
      <div class="modal-wrapper" data-test="production-outputsModal" v-on:click.self="$emit('close')">
        <div class="modal-container modal-container--fit">
          <div class="modal-header">
            <div class="title">Manage Outputs & Controllers</div>
            <button
              class="modal-close tb-btn tb-btn-text sm medium-em"
              data-test="production-outputsModal-close"
              @click.stop.prevent="$emit('close')"
            >
              <span class="fas fa-times" />
            </button>
          </div>

          <div v-if="enableStreamDeck" class="modal-primary-tabs">
            <button
              class="modal-primary-tab"
              :class="{ active: activeTab === 'outputs' }"
              @click="activeTab = 'outputs'"
            >
              Outputs
            </button>
            <button
              class="modal-primary-tab"
              :class="{ active: activeTab === 'controllers' }"
              @click="activeTab = 'controllers'"
            >
              Controllers
            </button>
          </div>

          <div class="modal-body">
            <keep-alive>
              <component :is="activeTabComponent"></component>
            </keep-alive>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ManageOutputsTab from './ManageOutputsTab.vue';
import ManageControllersTab from './ManageControllersTab.vue';

export default {
  name: 'ScreenModal',

  components: {
    ManageOutputsTab,
    ManageControllersTab,
  },

  data() {
    return {
      activeTab: 'outputs',
      enableStreamDeck: false,
    };
  },

  computed: {
    activeTabComponent() {
      if (this.activeTab === 'controllers' && this.enableStreamDeck) {
        return 'ManageControllersTab';
      }

      return 'ManageOutputsTab';
    },
  },

  mounted() {
    this.enableStreamDeck = this.$ld.has('enable-stream-deck', false);
    this.$ld.on(this.onChangeFlags);
  },

  beforeUnmount() {
    this.$ld.off(this.onChangeFlags);
  },

  watch: {
    enableStreamDeck(newVal) {
      if (!newVal && this.activeTab === 'controllers') {
        this.activeTab = 'outputs';
      }
    },
  },

  methods: {
    onChangeFlags() {
      this.enableStreamDeck = this.$ld.has('enable-stream-deck', false);
    },

    closeModal() {
      this.$emit('close');
      // Reset tab state so next time it opens it is back on outputs
      this.activeTab = 'outputs';
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  max-width: 720px;
}

.modal-primary-tabs {
  display: flex;
  gap: 1.5rem;
  margin: 0 2rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.modal-primary-tab {
  position: relative;
  margin: 0;
  padding: 0.75rem 0;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  cursor: pointer;
  transition: color 150ms ease-in-out;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: -1px;
    left: 0;
    height: 2px;
    background: transparent;
    transition: background-color 150ms ease-in-out;
  }

  &:hover,
  &:focus-visible {
    color: rgba(255, 255, 255, 0.85);
  }

  &:focus-visible {
    outline: 1px solid rgba(59, 130, 246, 0.9);
    outline-offset: 0.25rem;
  }

  &.active {
    color: #fff;

    &::after {
      background: #3b82f6;
    }
  }
}

.manage-screens {
  .modal-wrapper {
    align-items: flex-start;
    padding-top: 10vh;
  }
}

.closeModal {
  color: #fff;
  cursor: pointer;
  font-size: 1.5rem;
  transition: color 150ms ease-in-out;

  &:hover {
    color: #e5e5e5;
  }
}
</style>
